import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SchedaRecupero } from 'src/app/common/models/scheda-recupero';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";

@Component({
    selector: '[add_doc_to_scheda_recupero]',
  templateUrl: 'add-to-scheda-recupero.component.html',
})

export class AddDocumentoToSchedaRecuperoComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  entity: SchedaRecupero;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(schedaRecupero: SchedaRecupero) {
    this.onClickAddToEntity.emit(schedaRecupero);
  }
}
